export function hasExpired(cached) {
    if (!cached) {
        return false;
    }
    return cached.expiresAt && Date.now() >= cached.expiresAt;
}
